import { Box, Button, Typography } from "@material-ui/core";
import React from "react";
import moment from "moment";
import { prettifyPhoneNumber } from "../../../../helpers/phone-number";
import useAuth from "../../../../hooks/use-auth";
import CheckmarkButton from "../../../activation/components/CheckmarkButton";

type Props = {
  onContinue: () => void;
};

export default function AlreadyMembershipSubscription({ onContinue }: Props) {
  const { user, membershipSubscription } = useAuth();

  return (
    <>
      <Box marginBottom={8}>
        <Box mb={4}>
          <Typography variant="h5">
            You’re already an Airgraft member with active subscription.
          </Typography>
        </Box>

        <Box
          borderLeft={`8px solid`}
          borderColor="primary.main"
          bgcolor="common.white"
          boxShadow="0px 4px 4px rgba(0, 0, 0, 0.05)"
          borderRadius="4px"
          width="100%"
          display="flex"
          alignItems="center"
          paddingY={2}
        >
          <Box paddingX={2}>
            <CheckmarkButton checked />
          </Box>

          <Box display="flex" flexDirection="column" alignItems="flex-start">
            <Typography variant="body1">
              {user?.email || prettifyPhoneNumber(user?.phoneNumber)}
            </Typography>

            {membershipSubscription &&
              membershipSubscription.status === "ACTIVE" && (
                <>
                  <Typography variant="body2">
                    {membershipSubscription.membership.label}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Your next billing is on{" "}
                    {moment(membershipSubscription.expirationDate).format("L")}.
                  </Typography>
                </>
              )}
          </Box>
        </Box>
      </Box>

      <Box mt={2}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={onContinue}
        >
          Continue
        </Button>
      </Box>
    </>
  );
}
